import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { PPTBillData } from 'egov-api';


export const addPPTBillData = createSourcedAction('Add PPT Bill data', props<{ billsData: PPTBillData[]}>());
